import Api from '../utils/Api';
import { createNotification } from './notifications';
import { updateSession } from './sessions';

export const UPDATE_USER_REQUEST = 'UPDATE_USER_REQUEST';
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS';
export const UPDATE_USER_FAILURE = 'UPDATE_USER_FAILURE';

export const updateUserRequest = () => ({
  type: UPDATE_USER_REQUEST
});

export const updateUserSuccess = user => dispatch => {
  const messages = [{ text: 'User profile updated.', type: 'success' }];
  dispatch(createNotification(messages));
  dispatch(updateSession(user));
  return {
    type: UPDATE_USER_SUCCESS,
    user
  };
};

export const updateUserFailure = error => dispatch => {
  error.response.json().then(messages => {
    const errorMessages = messages.map(message => ({
      text: message,
      type: 'error'
    }));
    dispatch(createNotification(errorMessages));
    return {
      type: UPDATE_USER_FAILURE
    };
  });
};

export const updateUser = params => dispatch => {
  dispatch(updateUserRequest());
  return Api.updateProfile(params)
    .then(data => dispatch(updateUserSuccess(data)))
    .catch(error => dispatch(updateUserFailure(error)));
};



// WEBPACK FOOTER //
// ./src/actions/users.js